<div class="flex flex-col gap-2">
  @for (message of messages; track $index) {
    <p-message [severity]="message.severity" [text]="message.detail"></p-message>
  }
</div>
<div>
  <canvas #chartCanvas id="chart">{{ chart() }}</canvas>
</div>
<div id="result-details">
  <h3>{{ 'voting.result.details' | translate }}</h3>
  <div>{{ result().detail }}</div>
  <div>
    <ul *ngFor="let votingResultVote of result().votingResultDataByType" class="pl-4">
      <li
        *ngIf="
          votingResultVote.type !== 'blanc' &&
          (votingResultVote.count > 0 || votingResultVote.type.indexOf('candidate') !== -1)
        ">
        <ng-container
          [ngTemplateOutlet]="votingResultVote.type.indexOf('candidate') !== -1 ? candidateVote : yesNoVote"
          [ngTemplateOutletContext]="{ votingResultVote }">
        </ng-container>
      </li>
    </ul>
  </div>
</div>

<ng-template #yesNoVote let-votingResultVote="votingResultVote">
  <div>
    {{ votingResultVote.count }} {{ 'voting.result.details.' + votingResultVote.type | translate }}
    <ng-container *ngIf="!result().secret && votingResultVote.members !== undefined">
      {{ votingResultVote.members }}
    </ng-container>
  </div>
</ng-template>

<ng-template #candidateVote let-votingResultVote="votingResultVote">
  <div>
    {{ votingResultVote.name }}:
    <ng-container *ngIf="result().secret">
      <div>{{ votingResultVote.count }} {{ 'voting.result.details.for' | translate }}</div>
      <ng-container *ngIf="votingResultVote.count2">
        <div>{{ votingResultVote.count2 }} {{ 'voting.result.details.against' | translate }}</div>
      </ng-container>
    </ng-container>
    <ul *ngIf="!result().secret" class="pl-4">
      <li>
        {{ votingResultVote.count }} {{ 'voting.result.details.for' | translate }}: {{ votingResultVote.members }}
      </li>
      <li *ngIf="votingResultVote.count2">
        {{ votingResultVote.count2 }} {{ 'voting.result.details.against' | translate }}:
        {{ votingResultVote.members2 }}
      </li>
    </ul>
  </div>
</ng-template>
